import { DISCOVERY_LAB_DISTRICTS } from '../DiscoveryLabConfig.js';
import {
  EvidenceLabScene,
  type EvidenceLabRouteDefinition,
} from '../minigames/evidence-lab/EvidenceLabScene.js';
import {
  EARTH_MATERIALS_ASSETS,
  EARTH_MATERIALS_ASSET_LIST,
  canEnterEarthMaterialsYard,
  getMissingEarthMaterialsAssets,
} from './EarthMaterialsAssets.js';
import { EARTH_MATERIALS_INVESTIGATION } from './EarthMaterialsConfig.js';
import { canEnterDiscoveryObservatory } from '../discovery-observatory/DiscoveryObservatoryAssets.js';

export const EARTH_MATERIALS_SCENE_KEY = 'EarthMaterialsYard';

const ROUTE: EvidenceLabRouteDefinition = {
  sceneKey: EARTH_MATERIALS_SCENE_KEY,
  sceneTitle: 'EARTH MATERIALS YARD',
  district: DISCOVERY_LAB_DISTRICTS.earthMaterialsYard,
  previousScene: 'SoundVibrationDeck',
  previousLabel: 'SOUND & VIBRATION DECK',
  nextDistrict: DISCOVERY_LAB_DISTRICTS.discoveryObservatory,
  nextScene: 'DiscoveryObservatory',
  nextLabel: 'DISCOVERY OBSERVATORY',
  nextUnavailableMessage:
    'The summit path is unlocked. Discovery Observatory is awaiting its runtime QA gate.',
  config: EARTH_MATERIALS_INVESTIGATION,
  assets: {
    dormant: EARTH_MATERIALS_ASSETS.dormant,
    restored: EARTH_MATERIALS_ASSETS.restored,
    card: EARTH_MATERIALS_ASSETS.card,
  },
  assetList: EARTH_MATERIALS_ASSET_LIST,
  getMissing: getMissingEarthMaterialsAssets,
  canEnter: canEnterEarthMaterialsYard,
  canEnterNext: canEnterDiscoveryObservatory,
};

export class EarthMaterialsScene extends EvidenceLabScene {
  static readonly requiredImageKeys = EARTH_MATERIALS_ASSET_LIST.map(asset => asset.key);

  constructor() {
    super(ROUTE);
  }
}
